export default "__VITE_ASSET__c5776e7a__"